<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="baseRect">
      <div class="coachRect">
        <div v-if="data" class="coachInfo">
          <div class="icon">
            <van-image
              width="5em"
              height="5em"
              round
              fit="contain"
              :src="data.coach.icon?data.coach.icon:'/dive/defaultIcon.jpg'"
            />
          </div>
          <div v-if="data" class="bodyRect">
            <van-row>
              <van-col span="16" class="name">{{ data.coach.proName }}&nbsp;<span v-if="data.coach.pop" :style="'color:'+GetDiveMainBack()">({{ data.coach.pop }})</span>
              </van-col>
              <van-col span="8" class="info rigth">{{ data.coach.diveShopName }}</van-col>
            </van-row>
            <div v-if="data.commentScore" class="tagRect">
              <van-tag v-for="(item,index) in data.commentScore.tag" :key="index" :color="GetDiveMainBack()" round type="primary">{{ item }}</van-tag>
              <van-tag v-for="(item,index) in data.commentScore.tagBadly" :key="index" round type="danger">{{ item }}</van-tag>
            </div>
            <div class="body">
              {{ data.coach.about }}
            </div>
          </div>
        </div>
        <div class="chatRect">
          <div id="myChart" class="coathCommentChartRect" />
          <div class="values">
            <div v-for="(item,index) in coachIndicator" :key="index" class="bar">
              <van-row>
                <van-col span="16">{{ item.name }}</van-col>
                <van-col span="8" class="rigth">{{ ShowFloat(coachValues[index],1) }}</van-col>
              </van-row>
              <div class="barBack">
                <div class="barTop" :style="'width:'+(coachValues[index]*100/5)+'%;background-color:'+GetDiveMainBack()" />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div v-if="GetEnbaleDiveComment()" class="baseRect">
      <div class="title">
        点评
        <div style="float:right" @click="showAddComment=true"><i class="iconfont iconadd" /></div>
      </div>
      <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
        REVIEWS
      </div>
      <diveCommentList v-model="commentId" :comment-type="commentType" />
      <diveCommentAdd v-model="showAddComment" :comment-id="commentId" :comment-type="commentType" />

    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Tag, Image, ImagePreview } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowFloat, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetEnbaleDiveComment, GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
import diveCommentList from '@/components/diveCommentList'
import diveCommentAdd from '@/components/diveCommentAdd'
import { getDiveCommentConfigList } from '@/utils/baseData'
export default {
  components: {
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [ImagePreview.name]: ImagePreview,
    TopBar,
    diveCommentList,
    diveCommentAdd
  },
  data() {
    return {
      titleTop: '',
      title: '',
      backurl: '/dive',
      coachId: undefined,
      commentId: undefined,
      commentType: undefined,
      showAddComment: false,
      data: undefined,
      configList: [],
      coachIndicator: [],
      coachValues: []
    }
  },

  created() {
    this.titleTop = GetDiveTitle()
    this.coachId = this.$route.params.id
    getDiveCommentConfigList((data) => {
      this.configList = data.filter(item => item.type === 'Coach')
      console.log('config', this.configList)
      this.init(() => {
        setTimeout(() => {
          console.log('mounted')
          var config = this.initChartData()
          this.drawCoathCommentChartRect(config)
        }, 1)
      })
    })
  },
  mounted() {

  },
  methods: {
    GetEnbaleDiveComment,
    ShowFloat,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    init(callback) {
      request({
        url: '/DiveData/getCoachPage',
        method: 'post',
        params: { id: this.coachId }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.title = this.data.coach.proName + '教练'
        setTimeout(() => {
          this.commentType = 'Coach'
          this.commentId = this.coachId
        }, 1)
        if (callback) {
          callback()
        }
      })
    },
    initChartData() {
      this.coachIndicator = []
      this.coachValues = []
      console.log('this.data', this.data)
      this.configList.forEach(item => {
        this.coachIndicator.push({
          name: item.name,
          max: 5
        })
        switch (item.location) {
          case 'Loaction_0':this.coachValues.push(this.data.commentScore ? this.data.commentScore.score0 : 0); break
          case 'Loaction_1':this.coachValues.push(this.data.commentScore ? this.data.commentScore.score1 : 0); break
          case 'Loaction_2':this.coachValues.push(this.data.commentScore ? this.data.commentScore.score2 : 0); break
          case 'Loaction_3':this.coachValues.push(this.data.commentScore ? this.data.commentScore.score3 : 0); break
          case 'Loaction_4':this.coachValues.push(this.data.commentScore ? this.data.commentScore.score4 : 0); break
          case 'Loaction_5':this.coachValues.push(this.data.commentScore ? this.data.commentScore.score5 : 0); break
          case 'Loaction_6':this.coachValues.push(this.data.commentScore ? this.data.commentScore.score6 : 0); break
          case 'Loaction_7':this.coachValues.push(this.data.commentScore ? this.data.commentScore.score7 : 0); break
          case 'Loaction_8':this.coachValues.push(this.data.commentScore ? this.data.commentScore.score8 : 0); break
          case 'Loaction_9':this.coachValues.push(this.data.commentScore ? this.data.commentScore.score9 : 0); break
        }
      })

      var data = {
        radar: [
          {
            indicator: this.coachIndicator,
            center: ['50%', '50%'],
            radius: '35vw',
            nameGap: 3
          }
        ],
        series: [
          {
            type: 'radar',
            tooltip: {
              trigger: 'item'
            },
            symbol: 'none',
            lineStyle: {
              width: 1
            },
            areaStyle: {},
            data: [
              {
                value: this.coachValues,
                itemStyle: {
                  normal: {
                    color: '#00AFFF'
                  }
                }
              }
            ]
          }
        ]
      }
      return data
    },
    drawCoathCommentChartRect(data) {
      var dom = document.getElementById('myChart')
      // console.log('drawCoathCommentChartRect', dom)
      const myChart = this.$echarts.init(dom)
      // console.log('drawCoathCommentChartRect', myChart)
      // 绘制图表
      myChart.clear()
      myChart.setOption(data)
    }
  }
}
</script>
<style scoped>
.baseRect{
  position: relative;
    padding: 0 1em;
    margin-bottom: 0.5em;
    background-color: #fff;
}
.title
{
    padding-top: 1em;
    font-weight: 700;
}
.titleSmall{
    font-size: 0.8em;
    font-weight: 700;
    padding-top: 0.25em;
    padding-bottom: 1em;
}

.coachRect{
  padding: 1em 0;
}
.coachRect .coachInfo
{
  min-height: 5em;
  position: relative;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 0.5em;
  margin-bottom: 0.5em;
}

.coachRect .coachInfo .icon{
  width: 5em;
  position: absolute;
  left: 0;
  top:0;
}
.coachRect .coachInfo .bodyRect{
  margin-left: 6em;
  right: 0;
}
.coachRect .coachInfo .bodyRect .info{
  font-size: 0.6em;
    margin-bottom: 0.5em;
}
.coachRect .coachInfo .bodyRect .name{
  font-size: 0.9em;
  margin-bottom: 0.5em;
  font-weight: 700;
}
.coachRect .coachInfo .bodyRect .body{
  font-size: 0.7em;
  color: #999;
}
.chatRect{
  position: relative;
  min-height: calc(35vw - 2em);
}

.chatRect .coathCommentChartRect{
  width: 40vw;
  height: 35vw;
  position: absolute;
  left: -1em;
  top: -1em;
}

.chatRect .values{
  margin-left: calc(40vw - 0.5em);
  width: calc(60vw - 1.5em);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.chatRect .values .bar{
  width: calc(30vw - 1.5em);
  font-size: 0.6em;
  color: #999;
  padding:0.3em 0;

}
.chatRect .values .bar .barBack
{
  position: relative;
  width: 100%;
  height: 1em;
  background-color: #F0f0f0;
  border-radius: 1em;
  margin-top: 0.3em;
  overflow: hidden;
}
.chatRect .values .bar .barTop
{
  position: absolute;
  left: 0;
  height: 1em;
}

.tagRect{
  margin: 0.5em 0;
}
.tagRect span{
  margin: 0.2em;
}
</style>
